import { Routes } from '@angular/router';

export const projectRoutes: Routes = [
	{ path: 'project', loadComponent: () => import('./pages/project/project.component').then(m => m.ProjectComponent) },
	{ path: 'profiles', loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent) },
	{ path: 'roles', loadComponent: () => import('./pages/roles/roles.component').then(m => m.RolesComponent) },
	{ path: 'create-role', loadComponent: () => import('./pages/create-rol/create-rol.component').then(m => m.CreateRolComponent) },
	{ path: 'edit-role/:id', loadComponent: () => import('./pages/create-rol/create-rol.component').then(m => m.CreateRolComponent) },
	{ path: 'single-project', loadComponent: () => import('./pages/single-project/single-project.component').then(m => m.SingleProjectComponent) },
	{ path: 'single-project/:id', loadComponent: () => import('./pages/single-project/single-project.component').then(m => m.SingleProjectComponent) },
	{ path: 'massive-project', loadComponent: () => import('./pages/massive-project/massive-project.component').then(m => m.MassiveProjectComponent) },
	{ path: '**', redirectTo: 'project-management/project' },
];

